module.exports = "<ul> <li ng-repeat=\"form in forms\"> <a ng-click=handleClick(form)> <span class=post-band ng-style=\"{backgroundColor: form.color}\"></span> {{form.name}} </a> </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/add-post-survey-list.html
// module id = 741
// module chunks = 0